module.exports = __webpack_public_path__ + "img/img_article5_item_v3_hover.1888edec.png";